import { render, staticRenderFns } from "./GPayComponent.vue?vue&type=template&id=0149e1b1&scoped=true&"
import script from "./GPayComponent.vue?vue&type=script&lang=js&"
export * from "./GPayComponent.vue?vue&type=script&lang=js&"
import style0 from "./GPayComponent.vue?vue&type=style&index=0&id=0149e1b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0149e1b1",
  null
  
)

export default component.exports